import { MathHelper } from '@otas/utils/custom-components/panchang-calendar/kollavarsham/math-helper';

export class Util {
    static get weekdays() {
        return {
            0: { en: 'Monday', ml: 'തിങ്കൾ' },
            1: { en: 'Tuesday', ml: 'ചൊവ്വ' },
            2: { en: 'Wednesday', ml: 'ബുധൻ' },
            3: { en: 'Thursday', ml: 'വ്യാഴം' },
            4: { en: 'Friday', ml: 'വെള്ളി' },
            5: { en: 'Saturday', ml: 'ശനി' },
            6: { en: 'Sunday', ml: 'ഞായർ' }
        };
    }
    static julianDayToWeekday(julianDay) {
        return Util.weekdays[MathHelper.truncate(julianDay + 0.5) % 7];
    }
}
